import React, { useContext } from 'react'

interface IParallaxContainerContext {
  containerName: string | null
  activeSlideIndex: number
}

export const ParallaxContainerContext = React.createContext<IParallaxContainerContext>({
  containerName: null,
  activeSlideIndex: -1,
})

export const ParallaxContainerProvider = ParallaxContainerContext.Provider

export const useParallaxContainerContext = () => useContext(ParallaxContainerContext)

interface IParallaxSlideContext {
  containerName: string | null
  index: number
}

export const ParallaxSlideContext = React.createContext<IParallaxSlideContext>({
  containerName: null,
  index: -1,
})

export const ParallaxSlideProvider = ParallaxSlideContext.Provider

export const useParallaxSlideContext = () => useContext(ParallaxSlideContext)
